import React, { useState, useEffect } from 'react';
import '../css/trustsection.css';
import testimonialimg1 from '../assets/testimonialimg1.webp';
import testimonialimg2 from '../assets/testimonialimg2.webp';
import testimonialimg3 from '../assets/testimonialimg3.webp';
import testimonialimg4 from '../assets/testimonialimg4.webp';
import { Helmet } from 'react-helmet-async';

const testimonialsData = [
  {
    id: 1,
    name: "Sonal Gupta",
    location: "Pune",
    quote: "Their insurance expert wasn't pushy. They explained every detail patiently and helped me make the right choice.",
    image: testimonialimg1,
    cardType: "testimonial-card-default"
  },
  {
    id: 2,
    name: "Atul Rathi",
    location: "Delhi",
    quote: "Booked a consultation for ₹99 and got more value in 30 minutes than I ever expected. I now recommend Policy Samjho to everyone!",
    image: testimonialimg2,
    cardType: "testimonial-card-default"
  },
  {
    id: 3,
    name: "Priya Sharma",
    location: "Mumbai",
    quote: "Finding the right policy was overwhelming until I found Policy Samjho. Their guidance made it incredibly easy and clear.",
    image: testimonialimg3,
    cardType: "testimonial-card-default"
  },
  {
    id: 4,
    name: "Rahul Mahta",
    location: "Bangalore",
    quote: "Absolutely fantastic service! The team is knowledgeable and genuinely helps you choose the best plan for your family.",
    image: testimonialimg4,
    cardType: "testimonial-card-default"
  }
];

const TrustSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        (prevIndex + 2) % testimonialsData.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="trust-section">
      <Helmet>
        <title>Clarity in Insurance | What Users Say About Policy Samjho</title>
        <meta
          name="description"
          content="Discover why users trust Policy Samjho for insurance expert advice. Read real stories about how our policy consultation provides clarity in insurance."
        />
        <meta
          name="keywords"
          content="clarity in insurance, insurance expert advice, policy consultation, insurance guidance, understand insurance policy, insurance advice India, Policy Samjho reviews"
        />
        <link rel="canonical" href="https://policysamjho.com/trust" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Review",
            "itemReviewed": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Policy Samjho Users"
            },
            "reviewBody": "Policy Samjho provides expert insurance guidance and clarity, helping users compare policies and avoid mistakes through professional consultation."
          })}
        </script>
      </Helmet>

      <div className="trust-content-left">
        <p className="trust-small-heading">&gt;&gt;&gt; VOICES OF TRUST &lt;&lt;&lt;</p>
        <h1 className="trust-main-heading">
          Real People. Real Stories. <span className="highlight-yellow">Clarity in Insurance Decisions.</span>
        </h1>
        <p className="trust-description">
          At Policy Samjho, we simplify insurance so you can make smarter
          choices through expert policy consultation. Here’s what our users love:
        </p>
        <div className="trust-features-grid">
          <div className="trust-feature-item">
            <span className="trust-feature-icon">&#9745;</span>
            <div className="trust-feature-text">
              <h3 className="feature-title">Expert Insurance Guidance</h3>
              <p className="feature-description">
                No more hours wasted! I understood my policy details in minutes.
              </p>
            </div>
          </div>
          <div className="trust-feature-item">
            <span className="trust-feature-icon">&#9745;</span>
            <div className="trust-feature-text">
              <h3 className="feature-title">Honest Policy Consultation</h3>
              <p className="feature-description">
                I finally got advice I could trust – no sales pressure, just clarity.
              </p>
            </div>
          </div>
          <div className="trust-feature-item">
            <span className="trust-feature-icon">&#9745;</span>
            <div className="trust-feature-text">
              <h3 className="feature-title">Insurance Expert Advice</h3>
              <p className="feature-description">
                Their strategist explained everything clearly, without
                complicated jargon.
              </p>
            </div>
          </div>
          <div className="trust-feature-item">
            <span className="trust-feature-icon">&#9745;</span>
            <div className="trust-feature-text">
              <h3 className="feature-title">Understand Your Policy</h3>
              <p className="feature-description">
                From booking to buying, everything felt smooth, fast, and transparent.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="trust-testimonials-right">
        {testimonialsData.map((testimonial, index) => {
          const isTopCard = index === currentIndex;
          const isBottomCard = index === (currentIndex + 1) % testimonialsData.length;
          if (!isTopCard && !isBottomCard) {
            return null;
          }

          return (
            <div
              key={testimonial.id}
              className={`testimonial-card ${isTopCard ? 'active-top' : ''} ${isBottomCard ? 'active-bottom' : ''}`}
              style={{ zIndex: isTopCard ? 2 : 1 }}
            >
              <div className="testimonial-content">
                <div className="testimonial-header-name-location">
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  <p className="testimonial-location">{testimonial.location}</p>
                </div>
                <div className="rating">
                  &#9733;&#9733;&#9733;&#9733;&#9733;
                </div>
                <p className="testimonial-quote">
                  {testimonial.quote}
                </p>
              </div>
              <div className="testimonial-image-container">
                <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustSection;